import React, { useState } from 'react';
import Container from "../../../../components/Container";
import Popup from '../../../../components/Popup/Popup';
import PopupContent from '../../../../components/Popup/PopupContent';
import styles from './Desktop.module.css';
import activateArrow from '../../../../assets/images/login/activateArrow.png';
import { oneDineLogo } from '../../../../assets/images';
import backImg from '../../../../assets/images/Fireboard/back2_red.png';

export default function Desktop(props) {
    const { popup, history, onPress, closePopup } = props;

    const [fieldValue, setFieldValue] = useState('');

    const getPopupStyle = () => {
        let popupStyle = { width: '30.83vw', height: '13.384vh', justifyContent: 'center' };
        if (popup && popup.type === "spinner") {
            popupStyle = { width: "50%" };
        } else if (popup && popup.type === "popup") {
            popupStyle = { width: '30.83vw', height: '13.384vh', justifyContent: 'center' };
        }
        return popupStyle;
    }

    const login = () => {
        onPress && onPress(fieldValue);
        setFieldValue('');
    }

    const heading = 'Enter Your Login ID';

    return (
        <Container style={styles.container}>
            <Popup visible={!!popup} popupStyle={getPopupStyle()} closePopup={closePopup}>
                <PopupContent {...popup} />
            </Popup>
            <div className={styles.wrapper}>
                {window.ReactNativeWebView ?
                    <div className={styles.backButton} onClick={() => history.goBack()}>
                        <img src={backImg} className={styles.backImage} alt="" />
                    </div>
                    : null
                }
                <img src={oneDineLogo} className={styles.logo} alt="logo" />
                <div className={styles.wrapper}>
                    <div className={styles.heading}>{heading}</div>
                </div>
                <div className={styles.btnWrapper}>
                    <input type="text" placeholder="" value={fieldValue} onChange={event => setFieldValue(event.target.value)} className={styles.textInput} />
                    <button type="submit" onClick={login}>
                        <img src={activateArrow} className={styles.activate} alt="activateArrow" />
                    </button>
                </div>
            </div>
        </Container>
    );
}